import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";

function CargueCalificaciones(props) {
  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }
    axios
      .post(
        "https://suadesarrollo.azurewebsites.net/api/ArchivoCalificaciones?SolicitudId=" +
          props.idSolicitud,
        f,
      )

      .then((response) => {
        console.log(response.data);
        alert("Cargue con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <div>
                  Seleccione el archivo para cargar las calificaciones de la
                  solicitud, el sistema no realizara la carga si se presenta
                  alguna inconsistencia
                </div>
                <hr className="sidebar-divider" />
                <input
                  type="file"
                  name="files"
                  multiple
                  onChange={(e) => subirArchivos(e.target.files)}
                />
                <button
                  className="btn btn-primary"
                  onClick={() => insertarArchivos()}
                >
                  insertar archivos
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CargueCalificaciones;
